module.exports = __webpack_public_path__ + "img/default-img.d3d781e3.png";